import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import DescriptionIcon from "@mui/icons-material/Description";
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/dominicatrotrias" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/david-nemetz-6a3b6743b" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
        <a href={`${process.env.PUBLIC_URL}/resume.pdf`} target="_blank" rel="noreferrer" aria-label="View Resume"><DescriptionIcon /></a>
      </div>
      <p>A portfolio designed & built by <a href="https://github.com/dominicatrotrias/react-portfolio-nguyen" target="_blank" rel="noreferrer">David Michael Nemetz</a> with 💜</p>
    </footer>
  );
}

export default Footer;